export default __webpack_public_path__ + "images/video-calling-step-3.2cc70a339a4f4a80f7ff216417abf619.png";